import { render, staticRenderFns } from "./province.vue?vue&type=template&id=37cb7ae0&"
import script from "./province.vue?vue&type=script&lang=js&"
export * from "./province.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cb7ae0')) {
      api.createRecord('37cb7ae0', component.options)
    } else {
      api.reload('37cb7ae0', component.options)
    }
    module.hot.accept("./province.vue?vue&type=template&id=37cb7ae0&", function () {
      api.rerender('37cb7ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/province.vue"
export default component.exports